import { startClientNavigation } from 'navigation/clientNavigation';
import { activatePageArea } from 'navigation/pageArea';

// Runs once per full page load: brings the page area the layout printed
// (#page_content) to life and, on a page that opted in, starts client
// navigation from it.
export default function startSitePage(rootDocument) {
	const area = rootDocument.getElementById('page_content');
	if(!area) {
		return Promise.resolve();
	}
	startClientNavigation();
	return activatePageArea(area);
}
